export default __webpack_public_path__ + "static/media/home.3200228e.svg";